import {
  Sprite,
  Loader,
  Point,
  Ticker,
} from 'pixi.js';
import { clamp } from 'lodash';
import eventHub from '@/scripts/eventHub';
import vars from '../vars';
import state from '../state';

class HitArea {
  constructor(parent) {
    this.parent = parent;

    this.lerpedPosition = 0;
    this.bounds = null;

    this.rotationHandler = () => { this.rotation(); };

    this.ref = new Sprite();
    this.sprite = new Sprite(Loader.shared.resources['images/PLAIN_RED'].texture);
    this.ref.addChild(this.sprite);

    this.hitSquare = new Sprite(Loader.shared.resources['images/PLAIN_GREEN'].texture);
    this.ref.addChild(this.hitSquare);

    this.resize();
    this.rayWideHandler = () => this.resize();
    eventHub.$on('ray-wide-change', this.rayWideHandler);
    this.rayFarHandler = () => this.resize();
    eventHub.$on('ray-far-change', this.rayFarHandler);
    this.parent.ref.addChild(this.ref);
  }

  resize() {
    this.sprite.anchor = new Point(0.5, 1);
    this.sprite.width = vars.layout.STAGE_WIDTH / 1.5;
    this.sprite.height = vars.layout.HIT_AREA_BOTTOM - vars.layout.HIT_AREA_TOP;
    this.sprite.position.x = vars.layout.STAGE_WIDTH / 2;
    this.sprite.position.y = vars.layout.HIT_AREA_TOP / state.rayFar;
    this.bounds = this.sprite.getBounds();

    this.hitSquare.anchor = new Point(0.5, 1);
    this.hitSquare.position.x = this.sprite.position.x;
    this.hitSquare.position.y = this.sprite.position.y;
    this.hitSquare.width = (vars.layout.HIT_AREA_BOTTOM - vars.layout.HIT_AREA_TOP) * state.rayWide;
    this.hitSquare.height = vars.layout.HIT_AREA_BOTTOM - vars.layout.HIT_AREA_TOP;
  }

  bindRotation(interaction) {
    this.interaction = interaction;
    Ticker.shared.add(this.rotationHandler);
  }

  unbindRotation() {
    Ticker.shared.remove(this.rotationHandler);
  }

  rotation() {
    const position = this.interaction.center.x + this.interaction.point.x;
    const clamped = clamp(
      position,
      (this.bounds.left + this.hitSquare.width / 2),
      (this.bounds.right - this.hitSquare.width / 2),
    );
    this.lerpedPosition = state.delayFunction(clamped, this.lerpedPosition, state.delayFactor);
    this.hitSquare.position.x = this.lerpedPosition;
  }

  destroy() {
    eventHub.$off('ray-wide-change', this.rayWideHandler);
    eventHub.$off('ray-far-change', this.rayFarHandler);
    this.ref.destroy({ children: true });
  }
}

export default HitArea;
